var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-alert', {
    staticClass: "sa_note",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_c('div', [_c('strong', [_vm._v("節點標準電壓")]), _vm._v(" —— 各節點的額定電壓，作為電壓偏高／偏低判定的比較基準。 ")]), _c('ul', {
    staticClass: "mb-0 mt-1"
  }, [_c('li', [_c('strong', [_vm._v("請確認電壓型態")]), _vm._v("：線電壓與相電壓相差 √3 倍，填錯會使判定結果整體偏移。 ")]), _c('li', [_vm._v(" MPPT 層的標準電壓可按「"), _c('strong', [_vm._v("由MPPT串列對應產生")]), _vm._v("」建立，需先完成「MPPT串列對應」。 ")]), _c('li', [_vm._v(" 系統只檢查額定下限小於上限；標準值超出額定範圍仍可儲存，以便後續檢視異常。 ")])])]), _c('MasterDataTable', _vm._g({
    attrs: {
      "table": "node_voltage_configs",
      "def": _vm.def,
      "site-code": _vm.siteCode
    }
  }, _vm.$listeners))], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };